import { render } from "./logNotice.vue?vue&type=template&id=34630396"
import script from "./logNotice.vue?vue&type=script&lang=js"
export * from "./logNotice.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__